import { Injectable } from '@angular/core';

@Injectable()

export class CsvmapperService {

  constructor() {
  }

  map(data: any, fileName: any) {

    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: any) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'));
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n');

    var saving = document.createElement('a');

    const BOM = '\uFEFF'; // para ver los acentos correctamente en excel
    csv = BOM + csv;

    saving.href = 'data:attachment/csv,' + encodeURIComponent(csv);
    saving.download = fileName + '.csv';
    saving.click();
  }
}


// WEBPACK FOOTER //
// ./src/app/core/csv.service.ts